import { BACKEND_WS_PATH } from 'src/config';

const receivedMessagesUrl = `${BACKEND_WS_PATH}socket`;

const GUARDIAN_TOKEN = 'guardian_token';

const CURRENT_SOCKET = 'current_socket';

const channelType = {
  ROOM: 'room',
  WATCHTOWER: 'watchtower',
  OVERSEER_TEAM: 'team',
  ADMIN: null,
  OVERSEER: 'overseer',
};
const commonCommandType = {
  JOIN: 'join',
  ERROR: 'error',
};

const socketCommandType = {
  SOCKET_ERROR: 'socket_error',
};

const roomCommandType = {
  ACTION: 'action',
  CUSTOMER_CONNECTED: 'customer_connected',
  DELETED_ATTACHMENT: 'deleted_attachment',
  DELETED_DEPARTMENT_ATTACHMENT: 'deleted_department_attachment',
  FOUND_OPERATOR: 'found_operator',
  INFO: 'info',
  INPUT: 'input',
  INVALID_ATTACHMENT: 'invalid_attachment',
  INVALID_DEPARTMENT_ATTACHMENT: 'invalid_department_attachment',
  IS_READ: 'is_read',
  IS_TYPING: 'is_typing',
  JOIN: 'join',
  LEFT: 'left',
  NEW_ACTIVITY: 'new_activity',
  NEW_ATTACHMENT: 'new_attachment',
  NEW_DEPARTMENT_ATTACHMENT: 'new_department_attachment',
  NEW_MSG_FROM_DEPARTMENT: 'new_msg_from_department',
  NEW_MSG_TO_DEPARTMENT: 'new_msg_to_department',
  NEW_MSG: 'new_msg',
  ONHOLD_ACTIVITY: 'onhold_activity',
  PRESENCE_DIFF: 'presence_diff',
  PRESENCE_STATE: 'presence_state',
  QUESTION_DELIVERED: 'question_delivered',
  REPLY_DELIVERED: 'reply_delivered',
  STOP_ACTIVITY: 'stop_activity',
  TRANSFERED: 'transfered',
  UNABLE_TO_JOIN: 'unable_to_join',
  GET_LOST_MSG: 'get_lost_msg',
};

const watchtowerCommandType = {
  CHANGE_STATUS: 'status_changed',
  SET_STATUS: 'set_status',
  FORCE_LOGOUT: 'force_logout',
  SIMULTANEOUS_LOGIN: 'simultaneous_login',
  ACTION_ACTIVITY: 'action_activity',
};

const overseerTeamCommandType = {
  OPERATORS: 'operators',
  OVERSEER: 'overseer',
  CHANGE_OPERATOR_STATUS: 'change_operator_status',
  STATISTICS: 'statistics',
  ACTIVITY_QUEUE: 'activities_queue',
  AVERAGE_VOTES: 'average_votes',
  CONSOLIDATED_EVALUATION: 'consolidated_evaluation',
  AVERAGE_VOTES_FOR_OPERATORS: 'average_votes_for_operators',
  AVERAGE_VOTES_FOR_CHANNELS: 'average_votes_for_channels',
  AVERAGE_VOTES_FOR_REQUEST_TYPES: 'average_votes_for_request_types',
  OPERATIONAL_REPORTS_UPDATE: 'operational_reports_update',
};

const overseerCommandType = {
  CSV_REPORT_FINISHED: 'csv_report_finished',
  CSV_REPORT_FAILED: 'csv_report_failed',
  CSV_REPORT_IN_PROGRESS: 'csv_report_in_progress',
  CANCEL_CSV_REPORT: 'cancel_csv_report',
  CSV_REPORT_CANCELLED: 'csv_report_cancelled',
};

const commandType = {

  ...roomCommandType,
  ...watchtowerCommandType,
  ...overseerCommandType,
  ...overseerTeamCommandType,
  ...commonCommandType,
  ...socketCommandType,
};

const channels = new Map();

export {
  receivedMessagesUrl,
  GUARDIAN_TOKEN,
  CURRENT_SOCKET,
  channelType,
  socketCommandType,
  commandType,
  overseerCommandType,
  overseerTeamCommandType,
  watchtowerCommandType,
  roomCommandType,
  commonCommandType,
  channels,
};
